<template>
<div>
    <v-row>
        <v-checkbox
            v-model="is_enabled"
            label="Использовать WebHook"
            @change="changeWebhook()"
        ></v-checkbox>
    </v-row>
    <v-row v-if="is_enabled">
        <v-col cols="12">
            <v-select
                outlined
                v-model="type"
                :items="webhookActions"
                item-text="name"
                item-value="type"
                label="Выберите вебхук"
                persistent-hint
                @change="changeWebhook()"
            ></v-select>
        </v-col>
        <v-col cols="12" v-if="type == 'offer'">
            <v-select
                outlined
                v-model="action.webhookParameters.offer_id"
                :items="offers"
                item-text="name"
                item-value="id"
                label="Выберите оффер"
                persistent-hint
                @change="changeWebhook()"
            ></v-select>
            <v-textarea
                counter
                outlined
                :rules="rules"
                v-model="action.webhookParameters.text"
                label="Текст СМС сообщения"
                @blur="changeWebhook()"
            ></v-textarea>
            <b>{short_link}</b> - ссылка
        </v-col>
        <v-col cols="12" v-if="type == 'rega'">
            <v-textarea
                counter
                outlined
                :rules="rules"
                v-model="action.webhookParameters.text"
                label="Текст СМС сообщения"
                @blur="changeWebhook()"
            ></v-textarea>
            <b>{short_link}</b> - ссылка
        </v-col>
    </v-row>
</div>
</template>

<script>
export default {
    name: "webHook",
    props: [
        "element"
    ],
    data() {
        return {
            is_enabled: false,
            rules: [
                v => {
                    if (typeof(v) != "undefined") {
                        return v.length <= 200 || '200 символов уже, куда бежишь?'
                    } else {
                        return ''
                    }
                }
            ],
            action: {
                type: '',
                webhookUrl: '/api/webhook/zvonobot',
                webhookParameters: {},
            },
            type: '',
            webhookActions: [
                {
                    name: 'Отправить смс c регистрацией',
                    type: 'rega',
                },
                {
                    name: 'Отправить смс c офером',
                    type: 'offer',
                },
            ]
        }
    },
    created() {
        if (this.element.hasOwnProperty("webhookUrl")) {
            this.is_enabled = true;
            this.action.webhookUrl = this.element["webhookUrl"];
            this.action.webhookParameters = this.element["webhookParameters"];
            if (this.element["webhookParameters"].hasOwnProperty("offer_id")) {
                this.action.type = 'offer'
                this.type = 'offer'
            } else {
                this.action.type = 'rega'
                this.type = 'rega'
            }
        }
        this.$store.dispatch('GET_OFFERS');
    },
    computed: {
        offers() {
            return this.$store.getters.OFFERS;
        },
    },
    methods: {
        changeWebhook() {
            if (this.is_enabled) {
                this.action.type = this.type;
                if (this.action.webhookParameters.hasOwnProperty("offer_id") && this.action.type == 'rega') {
                    delete this.element["webhookParameters"].offer_id
                }
                this.element["webhookUrl"] = this.action.webhookUrl;
                this.element["webhookParameters"] = this.action.webhookParameters;
            } else {
                if (this.element.hasOwnProperty("webhookUrl")) {
                    delete this.element["webhookUrl"]
                }
                if (this.element.hasOwnProperty("webhookParameters")) {
                    delete this.element["webhookParameters"]
                }
            }
            this.element.ivrs.push();
        }
    }
}
</script>

<style>

</style>